<template>
  <div class="modal-dim on language-modal-dim">
    <div class="modal-wrap language-modal-wrap">
      <div class="modal-inner center language-modal-inner">
        <div class="modal language-modal">
          <div class="modal-head language-modal__head">
            <h1>{{ $t('modal.locale.title') }}</h1>
            <button
              type="button"
              class="language-modal__close"
              :aria-label="$t('modal.close')"
              @click="emit('close')"
            >
              <i class="i-modal-delete" aria-hidden="true"></i>
            </button>
          </div>

          <div class="modal-con radio language-modal__content">
            <div class="modal-txt">
              <ul class="language-ul" role="list">
                <li
                  class="language-li"
                  :class="{ selected: ($store.getters['locale/getLocale'] || 'ko') === 'ko' }"
                  role="button"
                  @click="changeLocale('ko')"
                >
                  <span class="language-option__main">
                    <img
                      class="language-option__flag"
                      src="@/assets/static/images/i-language-ko.svg"
                      alt=""
                    />
                    <span class="language-option__label">{{ $t('modal.locale.kr') }}</span>
                  </span>
                  <img
                    v-if="($store.getters['locale/getLocale'] || 'ko') === 'ko'"
                    class="language-option__check"
                    src="@/assets/static/images/i_checkbox-on.svg"
                    alt=""
                  />
                </li>
                <li
                  class="language-li"
                  :class="{ selected: ($store.getters['locale/getLocale'] || 'ko') === 'vn' }"
                  role="button"
                  @click="changeLocale('vn')"
                >
                  <span class="language-option__main">
                    <img
                      class="language-option__flag"
                      src="@/assets/static/images/i-language-vn.svg"
                      alt=""
                    />
                    <span class="language-option__label">{{ $t('modal.locale.vn') }}</span>
                  </span>
                  <img
                    v-if="($store.getters['locale/getLocale'] || 'ko') === 'vn'"
                    class="language-option__check"
                    src="@/assets/static/images/i_checkbox-on.svg"
                    alt=""
                  />
                </li>
                <li
                  class="language-li"
                  :class="{ selected: ($store.getters['locale/getLocale'] || 'ko') === 'en' }"
                  role="button"
                  @click="changeLocale('en')"
                >
                  <span class="language-option__main">
                    <img
                      class="language-option__flag"
                      src="@/assets/static/images/i-language-en.svg"
                      alt=""
                    />
                    <span class="language-option__label">{{ $t('modal.locale.en') }}</span>
                  </span>
                  <img
                    v-if="($store.getters['locale/getLocale'] || 'ko') === 'en'"
                    class="language-option__check"
                    src="@/assets/static/images/i_checkbox-on.svg"
                    alt=""
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Locale'
};
</script>
<script setup>
import LocaleManager from '@/common/utils/LocaleManager';

const emit = defineEmits(['close']);

const changeLocale = (locale) => {
  LocaleManager.setLocale(locale);
  emit('close');
};
</script>

<style scoped lang="scss">
.language-modal-inner {
  box-sizing: border-box;
  width: 100%;
  padding: 16px;
}

.language-modal {
  width: min(100%, 360px);
  min-width: 0;
  max-width: 360px;
  overflow: hidden;
  border: 1px solid #e5e9ed;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 12px 32px rgba(25, 50, 65, 0.12);
}

.language-modal__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 64px;
  padding: 16px 16px 16px 20px;
  border-bottom: 1px solid #eef1f3;
  text-align: left;
}

.language-modal__head h1 {
  min-width: 0;
  margin: 0;
  color: #25313a;
  font-size: 1.7rem;
  font-weight: 700;
  line-height: 1.3;
}

.language-modal__close {
  display: inline-flex;
  flex: 0 0 32px;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid #e4e8eb;
  border-radius: 50%;
  background: #ffffff;
  cursor: pointer;
}

.language-modal__close .i-modal-delete {
  margin: 0;
  opacity: 0.72;
  transform: scale(0.82);
}

.language-modal__close:hover {
  border-color: #b9e8f0;
  background: #f5fcfd;
}

.language-modal__content {
  min-height: 0;
  padding: 16px 20px 20px;
}

.language-modal__content .modal-txt {
  align-items: stretch;
  text-align: left;
}

.language-modal__content .language-ul {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin: 0;
  padding: 0;
  font-size: 1.4rem;
  font-weight: 500;
}

.language-modal__content .language-li {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 56px;
  width: 100%;
  margin: 0;
  padding: 12px 14px;
  border: 1px solid #e5e9ed;
  border-radius: 12px;
  background: #ffffff;
  color: #34424b;
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;
}

.language-modal__content .language-li:hover {
  border-color: #b9e8f0;
  background: #f8fdfe;
}

.language-modal__content .language-li.selected {
  border-color: #8fdce7;
  background: #f0fbfd;
  box-shadow: 0 3px 10px rgba(54, 202, 217, 0.1);
  color: #087c91;
  font-weight: 700;
}

.language-option__main {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 12px;
}

.language-option__flag {
  flex: 0 0 26px;
  width: 26px;
  height: 26px;
  object-fit: contain;
}

.language-option__label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.language-option__check {
  flex: 0 0 24px;
  width: 24px;
  height: 24px;
  object-fit: contain;
}

@media (max-width: 360px) {
  .language-modal-inner {
    padding: 12px;
  }

  .language-modal__content {
    padding-right: 16px;
    padding-left: 16px;
  }
}
</style>
/* *Created on 2023-08-30 *ProjectName user */
